import { render, staticRenderFns } from "./PagePart2.vue?vue&type=template&id=cfeb9810&scoped=true"
import script from "./PagePart2.vue?vue&type=script&lang=js"
export * from "./PagePart2.vue?vue&type=script&lang=js"
import style0 from "./PagePart2.vue?vue&type=style&index=0&id=cfeb9810&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfeb9810",
  null
  
)

export default component.exports